module.exports = __webpack_public_path__ + "static/img/ke.56262ac0.svg";